<template>
  <reference-filter
    class="reference-tag-filter"
    label="Tags"
    :count="count"
  >
    <reference-tag-chip-selector
      v-if="hasAvailableTags"
      v-model="selectedTagsModel"
      :available-tags="availableTags"
    />
    <span v-else class="grey--text text-body-2">
      No tags to filter by.
    </span>
  </reference-filter>
</template>

<script>
import ReferenceFilter from './ReferenceFilter';
import ReferenceTagChipSelector from '@/components/References/ReferenceTagChipSelector';
import { Tag } from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'ReferenceTagFilter',
  components: { ReferenceFilter, ReferenceTagChipSelector },
  props: {
    selectedTagIds: {
      type: Array,
      default: () => [],
    },
    availableTags: {
      type: Array,
      required: true,
      validator: (tags) => typeHelpers.isArrayOfType(tags, Tag),
    },
  },
  emits: ['update:selectedTagIds'],
  computed: {
    count() {
      return this.selectedTagIds.length;
    },
    hasAvailableTags() {
      return this.availableTags.length > 0;
    },
    selectedTagsModel: {
      get: function () {
        return (
          this.selectedTagIds?.map((id) =>
            this.availableTags.find((tag) => tag.id === id)
          ) || []
        );
      },
      set: function (value) {
        const newValues = value.map((tag) => tag.id);
        this.$emit(
          'update:selectedTagIds',
          newValues.length === 0 ? undefined : newValues
        );
      },
    },
  },
};
</script>
